import { getTeamsEmpList } from 'services/axios/emp'
import { getTeamsHierarchy, getTeamData } from 'services/axios/teams'

export const actions = {
  GET_TL_LIST: 'GET_TL_LIST',
  GET_ASSISTANT_MANAGER_LIST: 'GET_ASSISTANT_MANAGER_LIST',
  GET_MANAGER_LIST: 'GET_MANAGER_LIST',
  GET_TEAM_MEMBER: 'GET_TEAM_MEMBER',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
  HANDLE_SEARCHED_TEAM: 'HANDLE_SEARCHED_TEAM',
  GET_TEAM_LIST: 'GET_TEAM_LIST',
  GET_DEPARTMENT: 'GET_DEPARTMENT',
  GET_TEAM_EMP_LIST: 'GET_TEAM_EMP_LIST',
}

export const getHierarchy = ({ depId, process, locationId }) => {
  return async (dispatch) => {
    const response = await getTeamsHierarchy({ depId, process, locationId })
    dispatch({
      type: actions.GET_TEAM_MEMBER,
      payload: {
        amList: response.data.data.amList,
        managerList: response.data.data.managerList,
        tlList: response.data.data.tlList,
      },
    })
  }
}

export const getTeamsList = ({ skip, limit, searchedTeam, isActive }) => {
  return async (dispatch) => {
    const response = await getTeamData({ skip, limit, searchedTeam, isActive })
    dispatch({
      type: actions.GET_TEAM_LIST,
      payload: {
        teamList: response.data.data.teamTableData,
        totalCount: response.data.data.totalCount,
        teams: response.data.data.teamsList,
      },
    })
  }
}
export const getEmpListForTeam = ({ locationId, depId, processId }) => {
  return async (dispatch) => {
    const response = await getTeamsEmpList({ locationId, depId, processId })
    dispatch({
      type: actions.GET_TEAM_EMP_LIST,
      payload: response.data.data,
    })
  }
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}
export const handleSearchTeam = (searchedTeam) => {
  return {
    type: 'HANDLE_SEARCHED_TEAM',
    payload: searchedTeam,
  }
}
